(function () {
  function hexToHsl(hex){
    let r = parseInt(hex.slice(1,3), 16) / 255;
    let g = parseInt(hex.slice(3,5), 16) / 255;
    let b = parseInt(hex.slice(5,7), 16) / 255;
    const max = Math.max(r,g,b), min = Math.min(r,g,b);
    let h, s, l = (max + min) / 2;
    const d = max - min;
    if (d === 0){ h = 0; s = 0; }
    else {
      s = d / (1 - Math.abs(2*l - 1));
      switch(max){
        case r: h = ((g-b)/d) % 6; break;
        case g: h = (b-r)/d + 2; break;
        case b: h = (r-g)/d + 4; break;
      }
      h = Math.round(h * 60);
      if (h < 0) h += 360;
    }
    return [h, s*100, l*100];
  }

  function hslToHex(h, s, l){
    s /= 100; l /= 100;
    const c = (1 - Math.abs(2*l - 1)) * s;
    const x = c * (1 - Math.abs((h/60) % 2 - 1));
    const m = l - c/2;
    let r=0, g=0, b=0;
    if (h < 60)       { r=c; g=x; b=0; }
    else if (h < 120)  { r=x; g=c; b=0; }
    else if (h < 180)  { r=0; g=c; b=x; }
    else if (h < 240)  { r=0; g=x; b=c; }
    else if (h < 300)  { r=x; g=0; b=c; }
    else               { r=c; g=0; b=x; }
    const toHex = (v) => Math.round((v + m) * 255).toString(16).padStart(2,'0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  window.deriveZoneShades = function(baseHex){
    const [h, s, l] = hexToHsl(baseHex);
    const lightL = Math.min(l + 18, 92);
    const darkL  = Math.max(l - 18, 8);
    return {
      light: hslToHex(h, s, lightL),
      base:  baseHex,
      dark:  hslToHex(h, s, darkL)
    };
  };

  function applyVars(el, hex){
    const shades = window.deriveZoneShades(hex);
    el.style.setProperty('--zone-1', shades.base);
    el.style.setProperty('--zone-2', shades.dark);
    el.style.setProperty('--zone-light', shades.light);
    return shades;
  }

  // SITE-WIDE DEFAULT — Skin's brand color, hardcoded as the true fallback
  const SITE_DEFAULT_HEX = '#7a5fa9';
  applyVars(document.documentElement, SITE_DEFAULT_HEX);

  // PAGE-LEVEL override — exactly ONE per page (PDP wrapper, or manual section override)
  // This intentionally overwrites the global default, because a product page SHOULD show its own color
  const pageLevel = document.querySelector('[data-zone-color]');
  if (pageLevel) {
    const hex = pageLevel.getAttribute('data-zone-color');
    if (hex) applyVars(document.documentElement, hex);
  }

  // PER-CARD local color — MANY per page allowed (grids), never touches the global default
  document.querySelectorAll('[data-card-zone-color]').forEach((el) => {
    const hex = el.getAttribute('data-card-zone-color');
    if (hex) applyVars(el, hex);
  });
})();